import mitt, {Emitter} from 'mitt';
import {kapitelDateString, kapitelDateTimeString} from "@/graphql/kapitelTypes";
import {AInesObjectiveSubject, AvailabilityPlanningDates, Candidate} from "@/graphql/generated/graphql";
import {ChatSessionConfig} from "@/helper/chat/chatStore";
import {AppState} from "@/helper/appState";

export type GlobalEvents = {
    AppStateChanged: {state: AppState, impersonationUserSwitch: Boolean},
    "day:mutated" : kapitelDateString,
    "autopilotPreferences:mutated": kapitelDateString,
    "availabilityPlanningDates:mutated": AvailabilityPlanningDates,
    "availabilityPlanningMonth:mutated": kapitelDateString,
    "notification:date:clicked": kapitelDateString,
    "notification:month:clicked": kapitelDateString,
    "notification:bookingSuggestion:clicked": {employeeIds: number[]},
    "VoiceModeNewTextMessage" : string,
    "VoiceModeToggle" : boolean,
    ChatSessionConfigUpdated: ChatSessionConfig,
    CandidateUpdated: Candidate,
    FireFireworks: void,
    CloseAllModals: void,
    "objective:dirty" : AInesObjectiveSubject
}

const emitter = mitt();
const globalEmitter = mitt<GlobalEvents>()

export default function useEmitter(): Emitter<any> {
    return emitter;
}

export function useGlobalEmitter(): Emitter<GlobalEvents> {
    return globalEmitter;
}
